import { String } from 'aws-sdk/clients/acm';
import S3 from 'aws-sdk/clients/s3';
import { v4 as uuidv4 } from 'uuid';

const ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
const SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
const REGION = process.env.REACT_APP_AWS_REGION;
const BUCKET_NAME = process.env.REACT_APP_AWS_BUCKET;

const s3 = new S3({
    accessKeyId: ACCESS_KEY_ID,
    secretAccessKey: SECRET_ACCESS_KEY,
    region: REGION
});

export const createFolder = async (path: String, file: any = "") => {
    const params: any = { Bucket: BUCKET_NAME, Key: `${path}`, Body: file };
    const response = await s3.putObject(params).promise();
    return response;
};

export const putObject = async (path: String, fineName: String, file: any) => {
    const params: any = {
        Bucket: `${BUCKET_NAME}/${path}`,
        Key: fineName,
        Body: file,
        ContentType: file.type
    };
    const response = await s3.putObject(params).promise();
    return response;
};

export const getPresignedUrl = async (key: String) => {
    const params: any = {
        Bucket: BUCKET_NAME,
        Key: key,
        Expires: 3600, // URL expiration time in seconds
    };
    // const response = await s3.getSignedUrl("getObject", params);
    return new Promise((resolve, reject) => {
        s3.getSignedUrl('getObject', params, (err, url) => {
            if (err) {
                reject(err);
            } else {
                resolve(url);
            }
        });
    });
    // return response;
};

export const putFile = async (path: String, file: any) => {
    var splitedStr = file.name.split(".");
    splitedStr = splitedStr[splitedStr.length - 1];
    const fileName = `${uuidv4().toString()}.${splitedStr}`;
    putObject(path, fileName, file);
    return fileName;
}

export const downloadFile = (key: String) => {
    const params: any = {
        Bucket: BUCKET_NAME,
        Key: key,
    };

    return new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
            if (err) {
                console.error('Error downloading S3 object:', err);
            } else {
                const byteArray = new Uint8Array(data.Body as ArrayBuffer);
                const downloadUrl = URL.createObjectURL(new Blob([byteArray]));

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.target = '_blank';
                link.download = key;
                link.click();

                URL.revokeObjectURL(downloadUrl);

            }
        });
    });
};